import dateFormatType from '@/constants/dateFormatType';
import { formatDate } from '@/utils';
import { ServiceData } from '..';
/**
 * 서버로 보내야 하는 데이터들의 공통 분모와 공통 로직을 추가 한다.
 * formData를 서버로 보내는 requestbody로 변경 한다.
 */
// eslint-disable-next-line import/prefer-default-export
export class AbsWorkerNotice extends ServiceData {
    reqBody;
    constructor(form) {
        super();
        let targetType = 'WORKER_OF_DISTRIBUTOR';
        if (form.selectedHub === 'ALL' && form.targetType === 'ALL') {
            targetType = 'WORKER_OF_DISTRIBUTOR';
        }
        else if (form.targetType === 'ALL') {
            targetType = 'WORKER_OF_HUB';
        }
        else if (form.targetType === 'BY_WORKER') {
            targetType = 'BY_WORKER';
        }
        this.reqBody = {
            title: form.title,
            body: form.body,
            noticePeriodType: form.periodType === 'ALL' ? 'ENDLESS' : 'SELECTED',
            noticeStart: formatDate(new Date(form.selectedDate[0]), dateFormatType.DATE_NONE_HYPHEN),
            noticeEnd: formatDate(new Date(form.selectedDate[1]), dateFormatType.DATE_NONE_HYPHEN),
            workerNoticeTargetType: targetType,
            hubId: form.selectedHub,
            distributorId: form.distributorId,
            workers: form.selectedWorkerList,
        };
        if (form.id) {
            this.reqBody.id = form.id;
        }
    }
}
